import { render, staticRenderFns } from "./WindowsUpdate.vue?vue&type=template&id=1372c1fd&scoped=true"
import script from "./WindowsUpdate.vue?vue&type=script&lang=js"
export * from "./WindowsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1372c1fd",
  null
  
)

export default component.exports